const { ActionTypes } = require("../constants/action_types");

const initialState = "null";

export const projectDetailsReducer = (state = initialState, { type, payload }) => {

    switch (type) {
        case ActionTypes.PROJECT_DETAILS:
            return payload; //sidebarShow 
        default:
            return state;
    }
};
